// extracted by mini-css-extract-plugin
export var aircallIframe = "_jp-3";
export var fabContainer = "_jp-5";
export var fabRinging = "_jp-6";
export var loadingOverlay = "_jp-4";
export var pulse = "_jp-7";
export var widgetContent = "_jp-2";
export var widgetPanel = "_jp-0";
export var widgetPanelExpanded = "_jp-1";